import { create } from "zustand";
import { RepositoryManager } from "../../data/repositoryManager";
import type { TicketStatus } from "./TicketEnums";

export interface Ticket {
  id: number;
  user_id: number;
  subject: string;
  description?: string;
  type: number;
  type_label: string;
  type_icon: string;
  status: TicketStatus;
  admin_id: number | null;
  admin?: { id: number; name: string } | null;
  admin_notes?: string | null;
  resolved_at?: string | null;
  created_at: string;
  updated_at?: string;
}

interface TicketsState {
  ticketsData: any | null;
  ticketDetail: Ticket | null;
  isListLoading: boolean;
  isDetailLoading: boolean;
  isSaving: boolean;

  getTickets: (params?: any) => Promise<any>;
  getTicketById: (id: number) => Promise<any>;
  updateStatus: (
    id: number,
    status: TicketStatus,
    notes?: string
  ) => Promise<any>;
  assignTicket: (id: number, adminId: number | null) => Promise<any>;
  deleteTicket: (id: number) => Promise<any>;
}

const useTicketsStore = create<TicketsState>((set) => ({
  ticketsData: null,
  ticketDetail: null,
  isListLoading: false,
  isDetailLoading: false,
  isSaving: false,

  async getTickets(params = {}) {
    set({ isListLoading: true });
    try {
      const res = await RepositoryManager.ticketsAdmin.getTickets(params);
      if (res.success) {
        set({ ticketsData: res.data });
      }
      return res;
    } finally {
      set({ isListLoading: false });
    }
  },

  async getTicketById(id) {
    set({ isDetailLoading: true });
    try {
      const res = await RepositoryManager.ticketsAdmin.getDetail(id);
      if (res.success) {
        set({ ticketDetail: res.data });
      }
      return res;
    } finally {
      set({ isDetailLoading: false });
    }
  },

  async updateStatus(id, status, notes) {
    set({ isSaving: true });
    try {
      const res = await RepositoryManager.ticketsAdmin.updateStatus(id, {
        status,
        admin_notes: notes,
      });
      return res;
    } finally {
      set({ isSaving: false });
    }
  },

  async assignTicket(id, adminId) {
    set({ isSaving: true });
    try {
      const res = await RepositoryManager.ticketsAdmin.assign(id, adminId);
      return res;
    } finally {
      set({ isSaving: false });
    }
  },

  async deleteTicket(id) {
    set({ isSaving: true });
    try {
      const res = await RepositoryManager.ticketsAdmin.delete(id);
      return res;
    } finally {
      set({ isSaving: false });
    }
  },
}));

export default useTicketsStore;







